import './components/navigation-block';

// old site code
const googleMaps = require( './components/google-maps' );

// eslint-disable-next-line no-unused-vars
jQuery( document ).ready( function( $ ) {
	googleMaps();
} );
